import React from "react";
import LandlordHomepage from "../components/HomePages/LandlordHomepage";

export default function LandlordHomePage() {
  return <LandlordHomepage />;
}
